import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar'
import { ENVIRONMENT } from '@/config/constants'
import UserMenu from '@/pages/Home/UserMenu'

import HubbleLogo from './HubbleLogo'

export const HUBBLE_HEADER_HEIGHT = '3rem'

const HubbleHeader = () => {
  const { isMobile } = useSidebar()

  return (
    <div
      style={{ height: HUBBLE_HEADER_HEIGHT }}
      className='bg-elements-dark-shadow border-elements-dark-dimmed absolute top-0 z-50 flex w-full items-center border-b px-2 lg:pr-6 lg:pl-3'
    >
      <div className='flex flex-1 items-center space-x-2'>
        {isMobile ? (
          <SidebarTrigger className='text-elements-dark-contrastText/70 hover:text-elements-dark-contrastText' />
        ) : (
          <HubbleLogo />
        )}

        {ENVIRONMENT === 'production' ? (
          <span className='inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 py-0.5 text-xs font-semibold tracking-wider text-amber-400 uppercase'>
            <span className='h-1.5 w-1.5 animate-pulse rounded-full bg-amber-400' />
            production
          </span>
        ) : (
          <span className='inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2.5 py-0.5 text-xs font-semibold tracking-wider text-emerald-400 uppercase'>
            <span className='h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400' />
            {ENVIRONMENT}
          </span>
        )}
      </div>

      <UserMenu />
    </div>
  )
}

export default HubbleHeader
